import { z } from 'zod';
import { booleanQuery, idSchema } from './common.schema.js';
export const costCategoryListQuerySchema = z.object({
    includeInactive: booleanQuery(false),
});
/**
 * Cost categories mirror the KATEGORIA column the client filters on in Excel
 * (Materiały, Podwykonawca, Paliwo/Samochód, Narzędzia, …). In the spreadsheet
 * the same category exists in several spellings; here it is a real dictionary.
 */
export const costCategorySchema = z.object({
    id: idSchema,
    name: z.string(),
    sortOrder: z.number().int(),
    isActive: z.boolean(),
});
export const createCostCategorySchema = z.object({
    name: z.string().min(2, 'Podaj nazwę kategorii').max(60),
    /**
     * Position on the list, counted from 1. Optional: left out, the category
     * lands at the end, which is where a newly invented one belongs anyway.
     */
    sortOrder: z.number().int().min(1, 'Kolejność zaczyna się od 1').optional(),
});
export const updateCostCategorySchema = createCostCategorySchema
    .partial()
    .extend({ isActive: z.boolean().optional() });
//# sourceMappingURL=cost-category.schema.js.map